export default "__VITE_ASSET__BnbnO$c0__"